import {isRejectedWithValue} from '@reduxjs/toolkit'
import {setSearchBoxValues} from 'modules/searchBox/slice'

import {searchApi} from '@vio/core/src/sapi/services/searchApi'
import {offersSearchStarted} from '@vio/core/src/sapi/services/searchApi/action'

import {logEvent} from '../analytics/utils/logEvent'
import {MiddlewareType} from '../middlewareList'

const middleware: MiddlewareType = store => next => async action => {
  const {dispatch} = store
  const metadata = {
    params: action?.meta?.arg?.originalArgs || {},
    space: typeof window !== 'undefined' ? window.location.pathname : ''
  }
  const isBookingManagement = metadata.space.startsWith('/bookings')

  // Sync default dates from SAPI back to search box
  if (offersSearchStarted.match(action)) {
    const {checkIn, checkOut, rooms} = action.payload
    dispatch(
      setSearchBoxValues({
        checkIn,
        checkOut,
        rooms
      })
    )
  }

  // Booking Management specific logging - Migrated from legacy middleware
  if (
    searchApi.endpoints.getHotel.matchPending(action) &&
    isBookingManagement
  ) {
    logEvent(
      'Services.SAPI.Hotel.Start',
      metadata,
      undefined,
      'BookingManagement'
    )
  }

  if (
    searchApi.endpoints.getHotel.matchFulfilled(action) &&
    isBookingManagement
  ) {
    logEvent(
      'Services.SAPI.Hotel.Done',
      metadata,
      undefined,
      'BookingManagement'
    )
  }

  if (
    searchApi.endpoints.getHotel.matchRejected(action) &&
    isRejectedWithValue(action) &&
    isBookingManagement
  ) {
    logEvent(
      'Services.SAPI.Hotel.Error',
      metadata,
      'error',
      'BookingManagement'
    )
  }

  return next(action)
}
export default middleware
